import { render, staticRenderFns } from "./content-carousel.vue?vue&type=template&id=77bef66e"
import script from "./content-carousel.vue?vue&type=script&lang=js"
export * from "./content-carousel.vue?vue&type=script&lang=js"
import style0 from "./content-carousel.vue?vue&type=style&index=0&id=77bef66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports